import get from 'lodash/get';

const degreeNameToDataPathMap = [
  {
    name: 'Certificate',
    path: 'degreeOffering.certificates.value',
    offered: false,
  },
  {
    name: `Associate's`,
    path: 'degreeOffering.associates.value',
    offered: false,
  },
  {
    name: `Bachelor's`,
    path: 'degreeOffering.bachelors.value',
    offered: false,
  },
  {
    name: 'Graduate Certificate',
    path: 'degreeOffering.gradCertificates.value',
    offered: false,
  },
  {
    name: `Master's`,
    path: 'degreeOffering.masters.value',
    offered: false,
  },
  {
    name: 'Doctorate',
    path: 'degreeOffering.doctorates.value',
    offered: false,
  },
];

export const getDegreeOfferingList = majors => {
  const degreeToDataMap = [...JSON.parse(JSON.stringify(degreeNameToDataPathMap))];
  majors.forEach(major => {
    degreeToDataMap.forEach(map => {
      if (get(major, map.path, false)) {
        map.offered = true;
      }
    });
  });

  return degreeToDataMap.reduce((filtered, mapElement) => {
    if (mapElement.offered) {
      filtered.push(mapElement.name);
    }
    return filtered;
  }, []);
};
